import axios from "axios";

/**
 * Axios instance with properties
 */
export default axios.create({
    responseType: "json",
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});
